const e=`org`,t=`org_user`,n=[`org`,t];export{e as TARGET_ORG,t as TARGET_ORG_USER,n as TARGET_TYPES};
//# sourceMappingURL=targets.mjs.map